webpackJsonp([3,9,16,130,151],{

/***/ "4X5L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var pricingSubscriptionDirective_1 = __webpack_require__("5721");
var AsyncJSLoader_1 = __webpack_require__("JMS9");
var underscore_extensions_1 = __webpack_require__("R0iF");
var SubscriptionSvc_1 = __webpack_require__("VXOl");
var SubscriptionPredictPriceContainer_1 = __webpack_require__("edCO");
exports.SUBSCRIPTION_OPEN_MODAL = 'website/subscription/openModal';
var SubscriptionCtrl = (function () {
    SubscriptionCtrl.$inject = ["$scope", "$q", "$state", "$stateParams", "$rootScope", "AuthenticationSvc", "subscriptionMessageSvc", "analyticSvc", "typeformSvc", "subscriptionSvc", "TranslateSvc"];
    function SubscriptionCtrl($scope, $q, $state, $stateParams, $rootScope, AuthenticationSvc, subscriptionMessageSvc, analyticSvc, 
        // private upgradeOneProjectSvc: UpgradeOneProjectSvc,
        typeformSvc, subscriptionSvc, TranslateSvc) {
        var _this = this;
        this.$scope = $scope;
        this.$q = $q;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.AuthenticationSvc = AuthenticationSvc;
        this.subscriptionMessageSvc = subscriptionMessageSvc;
        this.analyticSvc = analyticSvc;
        this.typeformSvc = typeformSvc;
        this.subscriptionSvc = subscriptionSvc;
        this.TranslateSvc = TranslateSvc;
        this.isRedeem = this.$state.params.redeem;
        this.cbUpgradeResult = angular.noop;
        this.loading = false;
        this.confirmDowngradeShown = false;
        this.cancelModalShown = false;
        this.isChangeCard = false;
        this.upgradeResultShown = false;
        this.appSumoUpgradeResultShown = false;
        this.changeBillingShowNext = false;
        this.downgradeResultShown = false;
        this.switchToNewResultShown = false;
        this.upgradeProjectResultShown = false;
        this.cardEditSuccessShown = false;
        this.billingChangeSuccessShown = false;
        this.changeBillingShown = false;
        this.showEditCard = false;
        this.isStripe = function () { return _this.subscriptionSvc.isStripe(); };
        this.mapSpecialUpgrades = {
            'small-agency': 'WaveSmallAgency',
            agency: 'WaveBigAgency'
        };
        this.getStarterPricing = {
            monthlyPrice: 600,
            annualPrice: 6000
        };
        this.clearOpenModalListener = _.noop;
        this.clearPredictPriceErrorListener = _.noop;
        this.confirmDeleteCardShown = false;
        this.isConfirmDeleteCardPending = false;
        this.processResponse = function (httpResponse) {
            var deferred = _this.$q.defer();
            var response = httpResponse.data;
            if (underscore_extensions_1.Utils.isApiError(response)) {
                var errorMsg = _this.errorResponse(response);
                deferred.reject(errorMsg);
            }
            else {
                _this.successResponse().then(function () { return deferred.resolve(response); });
            }
            return deferred.promise;
        };
        this.stopLoading = function () { return (_this.loading = false); };
        this.isEmailCorrect = function () { return /^.+@.+$/.test(options.user.email) && options.user.emailConfirmed; };
        this.getAlternativePeriod = function () { return (_this.isMonthly() ? 'annual' : 'monthly'); };
        this.toggleConfirmDowngradeModal = function () { return (_this.confirmDowngradeShown = !_this.confirmDowngradeShown); };
        this.toggleCancelModal = function () {
            if (_this.cancelModalShown) {
                _this.cancelModalShown = false;
                _this.goDefaultState();
                _this.analyticSvc.upgradeShown('downgrade');
            }
            else {
                _this.changeModalUrl('cancel');
            }
        };
        this.toggleUpgradeResultModal = function (cb) {
            if (cb === void 0) { cb = angular.noop; }
            if (_this.upgradeResultShown) {
                _this.upgradeResultShown = false;
                _this.cbUpgradeResult = cb;
                _this.goDefaultState();
            }
            else {
                _this.changeModalUrl('thank-you');
                _this.cbUpgradeResult();
            }
        };
        this.toggleDowngradeResultModal = function () { return (_this.downgradeResultShown = !_this.downgradeResultShown); };
        this.toggleAppSumoUpgradeResultModal = function () { return (_this.appSumoUpgradeResultShown = !_this.appSumoUpgradeResultShown); };
        this.toggleSwitchToNewResultModal = function () { return (_this.switchToNewResultShown = !_this.switchToNewResultShown); };
        // toggleUpgradeProjectResultModal = () => {
        //     this.upgradeProjectResultShown = !this.upgradeProjectResultShown;
        //     if (!this.upgradeProjectResultShown) {
        //         this.upgradeOneProjectSvc.updateProjectArgs();
        //     }
        // };
        this.toggleChangeBilling = function () {
            if (_this.isStripe()) {
                _this.changeBillingShown = !_this.changeBillingShown;
                if (!_this.changeBillingShown) {
                    _this.goDefaultState();
                }
            }
            else {
                _this.changeBillingShowNext = true;
                _this.showEditCardDetails();
            }
        };
        this.hideBillingChangeSuccess = function () { return (_this.billingChangeSuccessShown = false); };
        this.$scope.$watch(function () { return _this.$stateParams.coupon; }, function () {
            _this.$rootScope.coupon = { code: _this.$stateParams.coupon };
        });
        this.productName = underscore_extensions_1.Utils.getProduct() === 'WAVE' ? 'Wave.video' : 'Studio';
        this.getUpgradeButtonName = pricingSubscriptionDirective_1.getUpgradeButtonName(TranslateSvc);
        if (/typeform/.test(document.referrer)) {
            this.subscriptionSvc.showSubscriptionCanceledMessage();
        }
        this.updateSubscriptionDetails();
        if (this.subscriptionSvc.cardDetailsCashed) {
            this.showDetails = this.isStripe();
            this.cardDetails = this.subscriptionSvc.cardDetailsCashed;
        }
        else if (this.subscriptionSvc.cardDetailsErrorMessage) {
            this.cardDetailsErrorMessage = this.subscriptionSvc.cardDetailsErrorMessage;
        }
        else {
            this.setCardDetails();
        }
        this.subscriptionSvc.setUpgradesDiscount();
        this.openModal();
        AsyncJSLoader_1.stripeLib().then(function () { return window.Stripe.setPublishableKey(options.user.stripeKey()); });
        this.setBillingPeriodScope();
        this.clearPredictPriceErrorListener = this.$rootScope.$on(SubscriptionPredictPriceContainer_1.PREDICT_PRICE_ERROR, function (e, message) { return (_this.responseError = message); });
        this.clearOpenModalListener = this.$rootScope.$on(exports.SUBSCRIPTION_OPEN_MODAL, function (e, _a) {
            var modal = _a.modal, params = tslib_1.__rest(_a, ["modal"]);
            return _this.changeModalUrl(modal, params);
        });
    }
    SubscriptionCtrl.prototype.showDeleteCardModal = function () {
        this.confirmDeleteCardShown = true;
    };
    SubscriptionCtrl.prototype.hideDeleteCardModal = function () {
        this.confirmDeleteCardShown = false;
    };
    SubscriptionCtrl.prototype.deleteCard = function () {
        var _this = this;
        if (this.isConfirmDeleteCardPending)
            return null;
        this.isConfirmDeleteCardPending = true;
        return this.subscriptionSvc
            .deleteCard()
            .then(function () {
            _this.cardDetails = null;
            _this.confirmDeleteCardError = null;
            _this.hideDeleteCardModal();
        })
            .catch(function (message) { return (_this.confirmDeleteCardError = message); })
            .finally(function () {
            _this.isConfirmDeleteCardPending = false;
        });
    };
    SubscriptionCtrl.prototype.$onDestroy = function () {
        this.clearOpenModalListener();
        this.clearPredictPriceErrorListener();
    };
    Object.defineProperty(SubscriptionCtrl.prototype, "upgrades", {
        get: function () {
            return this.$stateParams.special ? this.getSpecialUpgrades() : this.subscriptionSvc.getUpgrades();
        },
        enumerable: true,
        configurable: true
    });
    SubscriptionCtrl.prototype.setBillingPeriodScope = function () {
        var period = this.$stateParams.period;
        var currentPeriod = period && period.toLowerCase() === 'annual' ? 'ANNUAL' : 'MONTHLY';
        this.$scope.billing = { period: currentPeriod };
    };
    SubscriptionCtrl.prototype.applyCoupon = function (coupon) {
        this.responseError = '';
        this.subscriptionMessageSvc.hideMassage();
        this.$rootScope.$emit(SubscriptionSvc_1.APPLY_COUPON, coupon);
        this.$state.go(this.$state.current, { coupon: coupon }, { notify: false });
    };
    SubscriptionCtrl.prototype.goTo = function (url) {
        var product = underscore_extensions_1.Utils.getProduct().toLocaleLowerCase();
        this.$state.go(product + "-" + url);
    };
    SubscriptionCtrl.prototype.getBillingPrice = function (price, isRound) {
        if (isRound === void 0) { isRound = true; }
        var newPrice = (price *
            this.subscriptionSvc.calcDiscount(this.subscriptionSvc.upgradesDiscount || (this.isFree && this.subscriptionSvc.saleDiscount))) /
            100.0;
        return isRound ? Math.ceil(newPrice) : newPrice;
    };
    SubscriptionCtrl.prototype.getBillingSaving = function (upgrade) {
        var monthly = this.getBillingPrice(upgrade.monthlyPrice, false);
        var annual = this.getBillingPrice(upgrade.annualPrice, false);
        var save = monthly * 12 - annual;
        var saveFixed = Number(save.toFixed(2));
        return Math.ceil(saveFixed);
    };
    SubscriptionCtrl.prototype.isPriceShown = function () {
        var period = this.subscriptionDetails.billingPeriod.toLowerCase();
        return period === 'coupon' || options.user.isStripe();
    };
    SubscriptionCtrl.prototype.showUpgradeModal = function (upgrade, billingPeriod) {
        this.changeModalUrl('upgrade', {
            plan: upgrade.displayName,
            period: billingPeriod.toLowerCase()
        });
    };
    SubscriptionCtrl.prototype.getFree = function () {
        var free = {
            wave: {
                name: 'WaveFree',
                displayName: 'WaveFree'
            },
            studio: {
                name: 'Free',
                displayName: 'Free'
            }
        };
        return free[this.subscriptionSvc.product.toLowerCase()];
    };
    SubscriptionCtrl.prototype.getError = function (error) {
        return this.subscriptionSvc.getError(error);
    };
    SubscriptionCtrl.prototype.showChangeCardView = function () {
        this.isChangeCard = true;
        this.responseError = null;
    };
    SubscriptionCtrl.prototype.errorResponse = function (response) {
        this.responseError = '';
        if (!response)
            return true;
        var error = this.getError(response.error || response.message);
        if (error) {
            this.loading = false;
            this.responseError = error;
        }
        else {
            return false;
        }
        return error;
    };
    SubscriptionCtrl.prototype.successResponse = function () {
        var _this = this;
        this.AuthenticationSvc.notifyUserChange();
        return this.setCardDetails()
            .then(function () { return _this.AuthenticationSvc.updateUser(); })
            .then(function () { return _this.updateSubscriptionDetails(); })
            .finally(function () { return _this.stopLoading(); });
    };
    SubscriptionCtrl.prototype.setCardDetails = function () {
        var _this = this;
        this.loadingDetails = true;
        return this.subscriptionSvc
            .getCardDetails()
            .then(function (response) {
            _this.showDetails = _this.isStripe();
            _this.cardDetails = response;
        })
            .catch(function (message) { return (_this.cardDetailsErrorMessage = message); })
            .finally(function () {
            _this.loadingDetails = false;
            _this.loading = false;
        });
    };
    SubscriptionCtrl.prototype.changeSubscription = function (params) {
        this.loading = true;
        return this.subscriptionSvc
            .changeSubscription(params)
            .then(this.processResponse)
            .finally(this.stopLoading);
    };
    SubscriptionCtrl.prototype.upgradeSubscription = function (params, action) {
        var _this = this;
        if (action === void 0) { action = 'upgrade'; }
        var _a = this.subscriptionDetails, displayName = _a.displayName, billingPeriod = _a.billingPeriod;
        return this.changeSubscription(params).then(function (response) {
            if (_this.changeBillingShown) {
                _this.changeBillingPeriodRequestHandler(billingPeriod);
            }
            else {
                _this.upgradedTo = response.displayName;
                _this.analyticSvc.changeSubscription(action, displayName, billingPeriod, _this.upgradedTo, response.billingPeriod, response.chargedAmount / 100.0, params.couponCode);
                _this.toggleUpgradeModal();
                _this.addTransaction();
                _this.showResultModalByAction(action);
            }
        });
    };
    SubscriptionCtrl.prototype.showResultModalByAction = function (action) {
        switch (action) {
            case 'upgrade': {
                this.toggleUpgradeResultModal();
                break;
            }
            case 'downgrade': {
                this.toggleDowngradeResultModal();
                break;
            }
            case 'switch-to-new': {
                this.toggleSwitchToNewResultModal();
                break;
            }
        }
    };
    SubscriptionCtrl.prototype.upgradeWithToken = function (name, period, couponCode, upgradeModal, action) {
        if (couponCode === void 0) { couponCode = ''; }
        this.upgradeSubscription({ name: name, period: period, couponCode: couponCode }, action).then(function () {
            if (upgradeModal) {
                upgradeModal.chosen = false;
            }
        });
    };
    // upgradeProject(period: string,
    //                projectId: string,
    //                token: string,
    //                name: string,
    //                couponCode: string,
    //                upgradeModal: UpgradeModal) {
    //     this.loading = true;
    //
    //     return this.upgradeOneProjectSvc.upgrade(period, projectId, token, name, couponCode)
    //         .then(() => {
    //             this.upgradedTo = period;
    //             if (upgradeModal) {
    //                 upgradeModal.chosen = false;
    //             }
    //             this.toggleUpgradeProjectResultModal();
    //         })
    //         .finally(this.stopLoading.bind(this));
    // };
    SubscriptionCtrl.prototype.cancelSubscription = function () {
        var _this = this;
        this.loading = true;
        this.subscriptionSvc
            .cancelSubscription()
            .then(function () { return _this.goDefaultState(); })
            .then(function () { return _this.typeformSvc.openTypeFormCancel(); })
            .finally(function () { return (_this.loading = false); });
    };
    SubscriptionCtrl.prototype.changeBillingPeriod = function (period, couponCode) {
        var _this = this;
        if (couponCode === void 0) { couponCode = ''; }
        var currentSubscription = this.subscriptionDetails.name;
        var oldPeriod = this.subscriptionDetails.billingPeriod;
        return this.changeSubscription({
            period: period,
            name: currentSubscription,
            couponCode: couponCode
        }).then(function () { return _this.changeBillingPeriodRequestHandler(oldPeriod); });
    };
    SubscriptionCtrl.prototype.updateCard = function (token) {
        var _this = this;
        this.loading = true;
        return this.subscriptionSvc
            .updateCard(token)
            .then(this.processResponse)
            .then(function () {
            _this.showEditCard = false;
            _this.cardEditSuccessShown = true;
        })
            .finally(this.stopLoading);
    };
    SubscriptionCtrl.prototype.showEditCardDetails = function () {
        this.changeModalUrl('editCard', { plan: '', period: '' });
    };
    SubscriptionCtrl.prototype.handlerModalClose = function () {
        this.goDefaultState();
    };
    SubscriptionCtrl.prototype.changeBillingModalCloseHandler = function () {
        this.changeBillingShown = false;
        this.goDefaultState();
    };
    SubscriptionCtrl.prototype.upgradeModalCloseHandler = function () {
        this.$scope.upgradeModal.chosen = false;
        this.goDefaultState();
    };
    SubscriptionCtrl.prototype.hideCardEditSuccess = function () {
        this.cardEditSuccessShown = false;
        this.openNextModal();
    };
    SubscriptionCtrl.prototype.renewAppSumo = function () {
        this.changeModalUrl('upgrade', { plan: 'Business', period: 'annual' });
    };
    SubscriptionCtrl.prototype.isErrorRequiredFields = function (form) {
        return form && Object.keys(form.$error).length === 1 && form.$error.required;
    };
    SubscriptionCtrl.prototype.isMonthly = function () {
        return this.subscriptionDetails.billingPeriod.toLowerCase() === 'monthly';
    };
    SubscriptionCtrl.prototype.getAnnualSave = function () {
        return this.subscriptionSvc.getAnnualSave();
    };
    SubscriptionCtrl.prototype.getPrice = function () {
        return this.isMonthlyPeriod() ? this.subscriptionSvc.getMonthlyPrice() : this.subscriptionSvc.getAnnualPrice();
    };
    SubscriptionCtrl.prototype.updateSubscriptionDetails = function () {
        this.subscriptionDetails = this.subscriptionSvc.getDetails();
        this.isFree = this.subscriptionSvc.isFree();
        this.isHigh = this.subscriptionSvc.isHigh();
        this.isSpecial = this.subscriptionSvc.isSpecial();
        this.isAppSumo = this.subscriptionSvc.isAppSumo();
        this.planName = this.getPlanName();
    };
    SubscriptionCtrl.prototype.changeBillingPeriodRequestHandler = function (oldPeriod) {
        this.billingChangeSuccessShown = true;
        this.toggleChangeBilling();
    };
    SubscriptionCtrl.prototype.getPlanName = function () {
        var _a = this.subscriptionDetails, displayName = _a.displayName, billingPeriod = _a.billingPeriod;
        var period = /coupon/i.test(billingPeriod) ? '' : billingPeriod;
        return displayName + " " + period;
    };
    SubscriptionCtrl.prototype.openNextModal = function () {
        if (this.changeBillingShowNext) {
            this.changeBillingShown = true;
        }
    };
    SubscriptionCtrl.prototype.goDefaultState = function () {
        this.isRedeem = false;
        return this.$state.go(this.$state.current, {
            modal: '',
            plan: '',
            period: '',
            redeem: '',
            coupon: ''
        }, { notify: false });
    };
    SubscriptionCtrl.prototype.changeModalUrl = function (modal, params) {
        var _this = this;
        if (params === void 0) { params = {}; }
        var _a = this.subscriptionDetails, displayName = _a.displayName, billingPeriod = _a.billingPeriod;
        var extendParams = tslib_1.__assign({ plan: displayName, period: billingPeriod.toLowerCase() }, params);
        this.$state
            .go(this.$state.current, tslib_1.__assign({ modal: modal }, extendParams), { notify: false })
            .finally(function () { return _this.openModal(tslib_1.__assign({ modal: modal }, extendParams)); });
    };
    SubscriptionCtrl.prototype.addTransaction = function () {
        if (this.subscriptionSvc.totalPriceLastValue <= 0)
            return;
        var _a = this.subscriptionSvc.getDetails(), displayName = _a.displayName, billingPeriod = _a.billingPeriod;
        var subscriptionName = displayName + " - " + billingPeriod;
        this.analyticSvc.addTransaction("" + this.subscriptionSvc.totalPriceLastValue, subscriptionName);
    };
    SubscriptionCtrl.prototype.openModal = function (params) {
        var _this = this;
        var _a = tslib_1.__assign({}, this.$stateParams, params), modal = _a.modal, plan = _a.plan;
        this.setBillingPeriodScope();
        this.responseError = ''; // remove all previous errors
        this.subscriptionMessageSvc.hideMassage();
        this.isChangeCard = false;
        switch (modal) {
            case 'thank-you': {
                this.upgradedTo = plan;
                this.upgradeResultShown = true;
                break;
            }
            case 'cancel': {
                this.cancelModalShown = true;
                break;
            }
            case 'upgrade': {
                this.openChangeSubscriptionModal('upgrade').then(function () { return _this.toggleUpgradeModal(); });
                break;
            }
            case 'downgrade': {
                if (plan === 'Free') {
                    this.toggleCancelModal();
                }
                else {
                    this.openChangeSubscriptionModal('downgrade').then(function () { return _this.toggleUpgradeModal(); });
                }
                break;
            }
            case 'switch-to-new': {
                this.openChangeSubscriptionModal('switch-to-new').then(function () { return _this.toggleUpgradeModal(); });
                break;
            }
            case 'switch-period': {
                this.openChangeSubscriptionModal();
                this.toggleChangeBilling();
                break;
            }
            case 'editCard': {
                this.showEditCard = true;
                break;
            }
        }
    };
    SubscriptionCtrl.prototype.openChangeSubscriptionModal = function (action) {
        var _this = this;
        this.subscriptionPredictPrice = null; // needed for correct works ng-init directive
        return this.openCouponModalForFreeUser()
            .then(function () { return _this.subscriptionSvc.findSubscriptionByName(_this.$stateParams.plan); })
            .then(function (subscription) {
            _this.subscriptionPredictPrice = subscription;
            if (action) {
                _this.upgradeAction = action;
            }
        });
    };
    SubscriptionCtrl.prototype.openCouponModalForFreeUser = function () {
        var _this = this;
        if (!this.subscriptionSvc.isFree() || this.$stateParams.coupon)
            return this.$q.resolve();
        return this.subscriptionSvc
            .getSale(this.$stateParams.period)
            .then(function (_a) {
            var coupon = _a.coupon;
            _this.$state.go(_this.$state.current, tslib_1.__assign({}, _this.$stateParams, { coupon: coupon }));
            return _this.$q.reject();
        })
            .catch(function () { return _this.$q.resolve(); });
    };
    SubscriptionCtrl.prototype.toggleUpgradeModal = function () {
        if (!this.$scope.upgradeModal)
            this.$scope.upgradeModal = {};
        this.$scope.upgradeModal.chosen = !this.$scope.upgradeModal.chosen;
        if (!this.$scope.upgradeModal.chosen) {
            this.goDefaultState();
        }
    };
    SubscriptionCtrl.prototype.getSpecialUpgrades = function () {
        var specialUpgradeName = this.mapSpecialUpgrades[this.$stateParams.special];
        var specialUpgrade = this.subscriptionSvc.getUpgradesByName(specialUpgradeName);
        var specialUpgrades = [];
        this.$scope.billing.period = 'ANNUAL';
        specialUpgrade && specialUpgrades.push(specialUpgrade);
        return specialUpgrades;
    };
    SubscriptionCtrl.prototype.isMonthlyPeriod = function () {
        return (this.subscriptionDetails.monthlyPrice &&
            this.subscriptionDetails.billingPeriod.toLowerCase().includes('monthly'));
    };
    return SubscriptionCtrl;
}());
exports.SubscriptionCtrl = SubscriptionCtrl;
angular.module('animatronApp.settings').directive('subscription', function () { return ({
    controllerAs: 'SubscriptionCtrl',
    controller: SubscriptionCtrl
}); });
angular.module('animatronApp.settings').directive('subscriptionPage', function () { return ({
    templateUrl: __webpack_require__("py5d")
}); });


/***/ }),

/***/ "52SV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/coupon_c8a8bf7b58a0eaa02ff4fb0127722e25.html";

/***/ }),

/***/ "5721":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var AuthenticationSvc_1 = __webpack_require__("awAO");
var underscore_extensions_1 = __webpack_require__("R0iF");
var Subscriptions_1 = __webpack_require__("4X5L");
var plans = [
    'Guest',
    'Free',
    'WaveFree',
    'Starter',
    'Creator',
    'Pro',
    'Agency',
    'Business',
    'Corporate',
    'Ultimate'
]; // order make sense
exports.getUpgradeButtonName = function (translateSvc) { return function (planName) {
    var isUserLogged = !options.user.anonymous;
    var isFree = planName === 'Free';
    return !isUserLogged && isFree
        ? translateSvc.get('subscription.start-for-free')
        : translateSvc.get('get') + " " + planName;
}; };
var PricingSubscription = (function () {
    PricingSubscription.$inject = ["$scope", "$rootScope", "$element", "$state", "$stateParams", "$compile", "$attrs", "AuthenticationSvc", "subscriptionSvc", "TranslateSvc"];
    function PricingSubscription($scope, $rootScope, $element, $state, $stateParams, $compile, $attrs, AuthenticationSvc, subscriptionSvc, TranslateSvc) {
        var _this = this;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$element = $element;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$compile = $compile;
        this.$attrs = $attrs;
        this.AuthenticationSvc = AuthenticationSvc;
        this.subscriptionSvc = subscriptionSvc;
        this.TranslateSvc = TranslateSvc;
        this.product = underscore_extensions_1.Utils.getProduct().toLowerCase();
        this.settingsUrl = this.product + "/pricing";
        this.subscriptionSale = {};
        this.generalButtonClasses = 'select-button button button-big button-red';
        this.planName = $attrs.pricingSubscription;
        this.$scope.$watch('billing.period', function () { return _this.setButtonsAndSale(); });
        this.$rootScope.$on(AuthenticationSvc_1.USER_UPDATE_SUCCESS, function () { return _this.setButtons(); });
        this.getUpgradeButtonName = exports.getUpgradeButtonName(TranslateSvc);
        this.setButtonsAndSale();
    }
    PricingSubscription.prototype.setButtonsAndSale = function () {
        var _this = this;
        this.subscriptionSvc
            .getSale(this.getBillingPeriod())
            .then(function (sale) {
            _this.subscriptionSale = sale;
        })
            .finally(function () {
            _this.setButtons();
        });
    };
    PricingSubscription.prototype.setButtons = function () {
        this.removePreviousButton();
        if (options.user.anonymous) {
            this.insertSignUpButton();
        }
        else {
            if (this.planName ===
                this.subscriptionSvc.getDetails().displayName ||
                this.subscriptionSvc.isSameOldPlan(this.getBillingPeriod(), this.planName)) {
                this.insertCurrentPlanButton();
            }
            else if (!this.isLowerPlan()) {
                this.insertUpgradeButton();
            }
        }
    };
    PricingSubscription.prototype.removePreviousButton = function () {
        this.getButtonContainer(function (container) {
            var button = container.querySelector('.button');
            button && container.removeChild(button);
        });
    };
    PricingSubscription.prototype.insertUpgradeButton = function () {
        var _this = this;
        var classes = "button-orange " + this.generalButtonClasses;
        var getOpenModalParamsWrapper = function (action) {
            return _this.getOpenModalParams(action, _this.planName, _this.getBillingPeriod());
        };
        var insertButton = function (action) {
            return _this.insertButtonElement(classes, "href=\"#\" ng-click=\"PricingSubscription.openModal(" + getOpenModalParamsWrapper(action) + ")\"", _this.getUpgradeButtonName(_this.planName, options.handHeld));
        };
        if (this.isLowerPlan()) {
            insertButton('downgrade');
        }
        else {
            insertButton('upgrade');
        }
    };
    PricingSubscription.prototype.isLowerPlan = function () {
        var currentPlan = this.subscriptionSvc.getDetails().displayName;
        return (!_.contains(plans, currentPlan) ||
            plans.indexOf(currentPlan) >= plans.indexOf(this.planName));
    };
    PricingSubscription.prototype.insertCurrentPlanButton = function () {
        var classes = "button-orange button-bordered " + this.generalButtonClasses;
        var _a = this.subscriptionSvc.getDetails(), billingPeriod = _a.billingPeriod, displayName = _a.displayName;
        var period = this.getBillingPeriod();
        if (this.subscriptionSvc.isCurrentOldPlan()) {
            var params = this.getOpenModalParams('switch-to-new', displayName, period);
            this.insertButtonElement(classes, "href=\"#\" ng-click=\"PricingSubscription.openModal(" + params + ")\"", this.getUpgradeButtonName(this.planName, options.handHeld));
            return;
        }
        if (billingPeriod.toLowerCase() !== period && displayName !== 'Free') {
            var params = this.getOpenModalParams('switch-period', displayName, period);
            this.insertButtonElement(classes, "href=\"#\"  ng-click=\"PricingSubscription.openModal(" + params + ")\"", "subscription.switch-to-" + period);
        }
        else {
            this.insertButtonElement("button-gray " + classes, "", 'wv.prcng.crnt-pln');
        }
    };
    PricingSubscription.prototype.insertSignUpButton = function () {
        this.insertButtonElement("sign-up-now-btn " + this.generalButtonClasses, "href=\"#\"  ng-click=\"PricingSubscription.openSignUp('" + this.planName + "')\"", this.getUpgradeButtonName(this.planName, options.handHeld));
    };
    PricingSubscription.prototype.getButtonContainer = function (cb) {
        _.each(this.$element[0].querySelectorAll('.pricing-buttons'), cb);
    };
    PricingSubscription.prototype.insertButtonElement = function (classes, attrs, title) {
        var _this = this;
        var titleText = this.TranslateSvc.has(title)
            ? this.TranslateSvc.get(title)
            : title;
        var compileButton = function () {
            return _this.$compile("<a class=\"" + classes + "\" " + attrs + ">" + titleText + "</a>")(_this.$scope);
        };
        this.getButtonContainer(function (container) {
            return angular.element(container).append(compileButton());
        });
    };
    PricingSubscription.prototype.getOpenModalParams = function (action, planName, period) {
        var coupon = this.subscriptionSvc.isFree() && this.subscriptionSale.coupon
            ? ", coupon: '" + this.subscriptionSale.coupon + "'"
            : '';
        return "{modal: '" + action + "', plan: '" + planName + "', period: '" + period + "' " + coupon + "}";
    };
    PricingSubscription.prototype.openModal = function (params) {
        this.$rootScope.$emit(Subscriptions_1.SUBSCRIPTION_OPEN_MODAL, params);
    };
    PricingSubscription.prototype.openSignUp = function (planName) {
        var url = this.getUrl(planName);
        this.AuthenticationSvc.openSignUpPage(url);
    };
    PricingSubscription.prototype.getUrl = function (planName, action) {
        if (action === void 0) { action = 'upgrade'; }
        var isCurrentFree = planName === 'Free';
        var params = underscore_extensions_1.Utils.toParams(tslib_1.__assign({ plan: planName, period: this.getBillingPeriod() }, (this.subscriptionSvc.isFree() &&
            this.subscriptionSale.coupon && {
            coupon: this.subscriptionSale.coupon
        })));
        var dialogUrl = "/" + action + "?" + params;
        return isCurrentFree
            ? ''
            : underscore_extensions_1.Utils.getWebsiteUrl() + "pricing" + dialogUrl;
    };
    PricingSubscription.prototype.getBillingPeriod = function () {
        return this.$scope.billing.period.toLowerCase();
    };
    return PricingSubscription;
}());
exports.PricingSubscription = PricingSubscription;
angular
    .module('animatronApp.pricingSubscription', [])
    .directive('pricingSubscription', function () { return ({
    restrict: 'A',
    transclude: false,
    controller: PricingSubscription,
    controllerAs: 'PricingSubscription'
}); });


/***/ }),

/***/ "5T+r":
/***/ (function(module, exports, __webpack_require__) {

var InfoAppSumo = (function () {
    InfoAppSumo.$inject = ["$filter"];
    function InfoAppSumo($filter) {
        this.$filter = $filter;
        this.onRenew = this.onRenew || angular.noop;
        this.expirationMediumDate = this.$filter('date')(this.expirationDate * 1000, 'mediumDate');
    }
    InfoAppSumo.prototype.renew = function () {
        this.onRenew();
    };
    return InfoAppSumo;
}());
angular.module('animatronApp.settings').component('infoAppSumo', {
    bindings: {
        name: '<',
        displayName: '<',
        isFree: '<',
        price: '<',
        expirationDate: '<',
        onRenew: '&'
    },
    controller: InfoAppSumo,
    templateUrl: __webpack_require__("AMWW")
});


/***/ }),

/***/ "6B7s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/redeem-coupon_d0c35d468cb0c83c174fffaf9067a4e4.html";

/***/ }),

/***/ "AMWW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/info-app-sumo_e7389d67d8d687d427f604be76e0a338.html";

/***/ }),

/***/ "BYam":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Strings_1 = __webpack_require__("fxc3");
var lazy_modules_1 = __webpack_require__("bUzP");
var underscore_extensions_1 = __webpack_require__("R0iF");
var SubscriptionPlan = (function () {
    SubscriptionPlan.$inject = ["$scope", "$stateParams", "$element", "$ocLazyLoad", "analyticSvc", "subscriptionSvc"];
    function SubscriptionPlan($scope, $stateParams, $element, $ocLazyLoad, analyticSvc, subscriptionSvc) {
        var _this = this;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$element = $element;
        this.$ocLazyLoad = $ocLazyLoad;
        this.analyticSvc = analyticSvc;
        this.subscriptionSvc = subscriptionSvc;
        this.SubscriptionCtrl = this.$element.controller('subscription');
        $scope.upgradeModal = $scope.upgradeModal || {};
        underscore_extensions_1.Utils.sequence(lazy_modules_1.jqueryPaymentLib, $ocLazyLoad).then(function () {
            if (!Strings_1.Strings.isBlank($stateParams.plan) && (!$stateParams.modal || $stateParams.modal === 'upgrade')) {
                $scope.upgradeModal.chosen = $stateParams.plan === $scope.upgrade.displayName;
                $scope.$apply();
            }
        });
        $scope.$watch('upgradeModal.chosen', function (newVal) {
            newVal && _this.analyticSvc.upgradeShown(_this.$scope.action, _this.$scope.upgrade.displayName);
            _this.SubscriptionCtrl.responseError = '';
        });
    }
    SubscriptionPlan.prototype.handlerClick = function () {
        if (this.isFree()) {
            this.SubscriptionCtrl.toggleCancelModal();
        }
        else {
            this.showUpgradeDialog();
        }
    };
    SubscriptionPlan.prototype.isMostPopular = function () {
        return ['Pro', 'WavePro'].includes(this.$scope.upgrade.name);
    };
    SubscriptionPlan.prototype.getAnnualPrice = function () {
        return this.subscriptionSvc.getAnnualPrice(this.$scope.upgrade);
    };
    SubscriptionPlan.prototype.getMonthlyPrice = function () {
        return this.subscriptionSvc.getMonthlyPrice(this.$scope.upgrade);
    };
    SubscriptionPlan.prototype.isFree = function () {
        return this.subscriptionSvc.isFree(this.$scope.upgrade);
    };
    SubscriptionPlan.prototype.showUpgradeDialog = function () {
        if (this.$scope.action === 'upgrade') {
            this.SubscriptionCtrl.showUpgradeModal(this.$scope.upgrade, this.$scope.billing.period);
        }
        else {
            this.$scope.upgradeModal.chosen = true;
        }
    };
    return SubscriptionPlan;
}());
angular.module('animatronApp.settings').directive('subscriptionPlan', function () { return ({
    restrict: 'E',
    transclude: true,
    require: '^subscription',
    controller: SubscriptionPlan,
    controllerAs: '$ctrl',
    templateUrl: __webpack_require__("Er9j")
}); });


/***/ }),

/***/ "Er9j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/choose-plan_59ef82cee952f9a72d2ce58f92548d34.html";

/***/ }),

/***/ "F5f2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-types_08708959e72a6dd1f0273a228b640160.html";

/***/ }),

/***/ "JMS9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AsyncJSLoader = (function () {
    function AsyncJSLoader() {
    }
    return AsyncJSLoader;
}());
AsyncJSLoader.getAMDLibrary = _.memoize(function (libraryUrl, globalVariable) {
    return _.once(function (overridenLibraryUrl) {
        libraryUrl = overridenLibraryUrl || libraryUrl;
        console.log('Loading', libraryUrl);
        return new Promise(function (resolve) {
            return loadScripts([libraryUrl], function (lib) { return resolve((window[globalVariable] || lib)); });
        });
    });
});
/**
 * define all async libraries here
 */
exports.googleMapsLib = AsyncJSLoader.getAMDLibrary('https://maps.googleapis.com/maps/api/js');
exports.stripeLib = AsyncJSLoader.getAMDLibrary('https://js.stripe.com/v2/', 'Stripe');
exports.reamazeLib = AsyncJSLoader.getAMDLibrary('https://d3itxuyrq7vzpz.cloudfront.net/assets/reamaze.js', 'Reamaze');
exports.clipboardLib = AsyncJSLoader.getAMDLibrary('https://cdnjs.cloudflare.com/ajax/libs/clipboard.js/1.5.5/clipboard.min.js', 'Clipboard');


/***/ }),

/***/ "Lb+m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Strings_1 = __webpack_require__("fxc3");
var AsyncJSLoader_1 = __webpack_require__("JMS9");
var lazy_modules_1 = __webpack_require__("bUzP");
var underscore_extensions_1 = __webpack_require__("R0iF");
var testScope = {
    card_exp_month: '12',
    card_exp_year: '17',
    card: {
        number: '4242 4242 4242 4242',
        expiry: {
            month: 12,
            year: new Date()
                .getFullYear()
                .toString()
                .slice(2)
        },
        cvc: '123'
    }
};
var getHashByFormData = function (formData) {
    return window.btoa(_.values(formData)
        .map(function (v) { return v.replace(/\s*/g, ''); })
        .join(''));
};
var getStripeData = function (stripForm) {
    return window.Stripe.utils.paramsFromForm(stripForm, window.Stripe.card.whitelistedAttrs);
};
var getHashByStripeForm = _.compose(getHashByFormData, getStripeData);
var IdempotencyHeader = 'Idempotency-Key';
var StripeForm = (function () {
    StripeForm.$inject = ["$scope", "$element", "$timeout", "$ocLazyLoad", "$stateParams", "$rootScope", "HttpSvc", "subscriptionSvc", "AuthenticationSvc"];
    function StripeForm($scope, $element, $timeout, $ocLazyLoad, $stateParams, $rootScope, HttpSvc, subscriptionSvc, AuthenticationSvc) {
        var _this = this;
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$ocLazyLoad = $ocLazyLoad;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.HttpSvc = HttpSvc;
        this.subscriptionSvc = subscriptionSvc;
        this.AuthenticationSvc = AuthenticationSvc;
        var ctrl = $element.controller('subscription');
        $scope.stripeLoaded = false;
        $scope.pluginsLoaded = false;
        $scope.card = {};
        $rootScope.coupon = { code: $stateParams.promo || $stateParams.coupon };
        $scope.setRequiredFields = function () { return ($scope.requiredFields = false); };
        AsyncJSLoader_1.stripeLib().then(function () {
            $scope.stripeLoaded = true;
            $scope.submit = function (upgradeModal) {
                $scope.requiredFields = true;
                $timeout(function () {
                    if ($scope.stripeForm.$invalid)
                        return;
                    var stripeForm = angular.element($element)[0];
                    var idempotencyKey = getHashByStripeForm(stripeForm);
                    ctrl.loading = true;
                    window.Stripe.setPublishableKey(options.user.stripeKey()); //IE 10 problems
                    window.Stripe._allowedCustomHeaders.push(IdempotencyHeader);
                    window.Stripe._setCustomHeader(IdempotencyHeader, idempotencyKey);
                    var formParams = {
                        token: '',
                        name: $scope.upgrade ? $scope.upgrade.name : '',
                        period: $scope.billing.period.toUpperCase(),
                        email: undefined,
                        couponCode: undefined
                    };
                    var email = $scope.card.email;
                    if (!Strings_1.Strings.isBlank(email))
                        formParams.email = email;
                    window.Stripe.createToken(stripeForm, function (status, tokenResponse) {
                        if (!ctrl.errorResponse(tokenResponse)) {
                            var token = tokenResponse.id;
                            var resolvePromise = void 0;
                            formParams.token = token;
                            if (ctrl.showEditCard) {
                                resolvePromise = ctrl.updateCard(token);
                            }
                            else {
                                formParams.couponCode =
                                    $rootScope.coupon.code;
                                // if ($scope.upgrade.project) {
                                //     ctrl.upgradeProject(formParams.period,
                                //         $scope.upgrade.projectId,
                                //         formParams.token,
                                //         formParams.name,
                                //         formParams.couponCode,
                                //         upgradeModal
                                //     );
                                // } else {
                                var _a = tokenResponse.card, exp_month = _a.exp_month, exp_year = _a.exp_year;
                                subscriptionSvc.checkExpired(exp_month + "/" + exp_year);
                                resolvePromise = ctrl.upgradeSubscription(formParams);
                                // }
                            }
                            if (!Strings_1.Strings.isBlank(email)) {
                                resolvePromise.finally(function () {
                                    return _this.updateEmail(email);
                                });
                            }
                        }
                    });
                });
            };
            $scope.$apply();
        });
        underscore_extensions_1.Utils.sequence(lazy_modules_1.jqueryPaymentLib, $ocLazyLoad).then(function () {
            $scope.pluginsLoaded = true;
            $scope.$apply();
        });
        $scope.showFillTestCard = !true;
        $scope.fillTestCard = function () {
            ['number', 'expiry_year', 'expiry_month', 'cvc'].forEach(function (k) {
                $scope.stripeForm[k].isValid = true;
            });
            _.extend($scope, testScope);
        };
    }
    StripeForm.prototype.updateEmail = function (email) {
        var _this = this;
        this.HttpSvc('profile')
            .securePut({ email: email })
            .then(function () { return _this.AuthenticationSvc.updateUser(); });
    };
    return StripeForm;
}());
angular.module('animatronApp.settings').directive('stripeForm', function () { return ({
    restrict: 'E',
    require: '^subscription',
    transclude: true,
    controller: StripeForm,
    template: "<form form-autofill-fix name=\"stripeForm\" ng-submit=\"submit(upgradeModal)\" id=\"stripe-form\" class=\"form-horizontal\"><ng-transclude></ng-transclude></form>"
}); });


/***/ }),

/***/ "Pzqj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionPriceBlock = (function () {
    SubscriptionPriceBlock.$inject = ["subscriptionSvc"];
    function SubscriptionPriceBlock(subscriptionSvc) {
        this.subscriptionSvc = subscriptionSvc;
    }
    SubscriptionPriceBlock.prototype.$onChanges = function () {
        if (!this.discount)
            return;
        this.discountedAnnual = this.getDiscountPrice(this.annual);
        this.discountedMonthly = this.getDiscountPrice(this.monthly);
    };
    SubscriptionPriceBlock.prototype.getDiscountPrice = function (price) {
        return this.subscriptionSvc.round(price * this.subscriptionSvc.calcDiscount(this.discount));
    };
    return SubscriptionPriceBlock;
}());
angular.module('animatronApp.settings').component('subscriptionPriceBlock', {
    bindings: {
        monthly: '<',
        annual: '<',
        discount: '<'
    },
    controller: SubscriptionPriceBlock,
    templateUrl: __webpack_require__("o701")
});


/***/ }),

/***/ "VXOl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var underscore_extensions_1 = __webpack_require__("R0iF");
var AuthenticationSvc_1 = __webpack_require__("awAO");
exports.UPDATE_SUBSCRIPTION_CARD = 'website/subscription/updateCard';
exports.APPLY_COUPON = 'website/subscription/applyCoupon';
exports.CouponCompaniesNames = {
    prod: {
        AppSumo117: {
            title: 'AppSumo'
        },
        MightyDeals417: {
            title: 'MightyDeals'
        },
        StackSocial0718: {
            title: 'StackSocial'
        },
        'StackSocial0219-1A': {
            title: 'StackSocial'
        },
        defaultCompany: {
            title: 'Company'
        }
    },
    dev: {
        MightyDeals417: {
            title: 'AppSumo'
        },
        MightyDeals417Test: {
            title: 'MightyDeals'
        },
        StackSocial0718: {
            title: 'StackSocial'
        },
        'StackSocial0219-1A': {
            title: 'StackSocial'
        },
        defaultCompany: {
            title: 'Company'
        }
    }
}[ true ? 'prod' : 'dev'];
var SubscriptionSvc = (function () {
    SubscriptionSvc.$inject = ["$q", "$filter", "$http", "$rootScope", "$state", "TranslateSvc", "analyticSvc", "AuthenticationSvc", "affiliateSvc", "$cacheFactory", "HttpSvc"];
    function SubscriptionSvc($q, $filter, $http, $rootScope, $state, TranslateSvc, analyticSvc, AuthenticationSvc, affiliateSvc, $cacheFactory, HttpSvc) {
        var _this = this;
        this.$q = $q;
        this.$filter = $filter;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.TranslateSvc = TranslateSvc;
        this.analyticSvc = analyticSvc;
        this.AuthenticationSvc = AuthenticationSvc;
        this.affiliateSvc = affiliateSvc;
        this.$cacheFactory = $cacheFactory;
        this.HttpSvc = HttpSvc;
        this.getSaleCache = this.$cacheFactory('get-sale');
        this.specialSubscriptionNames = ['WaveBigAgency', 'WaveSmallAgency'];
        this.handlerHttpResponse = function (res) {
            var deferred = _this.$q.defer();
            if (res && res.data && underscore_extensions_1.Utils.isApiError(res.data)) {
                deferred.reject(res.data.message);
                console.error('subscription error: ', res.data);
            }
            else {
                deferred.resolve(res.data);
            }
            return deferred.promise;
        };
        this.$rootScope.$on(AuthenticationSvc_1.USER_LOGOUT, function () {
            _this.upgradesDiscount = undefined;
            _this.cardDetailsCashed = undefined;
            _this.cardDetailsErrorMessage = undefined;
            _this.clearCache();
        });
    }
    SubscriptionSvc.prototype.clearCache = function () {
        this.getSaleCache.removeAll();
    };
    SubscriptionSvc.isStripeError = function (error) {
        return error && error.message && error.type;
    };
    Object.defineProperty(SubscriptionSvc.prototype, "product", {
        get: function () {
            return underscore_extensions_1.Utils.getProduct();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionSvc.prototype, "productParams", {
        get: function () {
            return { params: { product: this.product } };
        },
        enumerable: true,
        configurable: true
    });
    SubscriptionSvc.prototype.getError = function (error) {
        if (!error)
            return null;
        if (_.isString(error)) {
            return (this.getStripeCouponError(error) ||
                this.getRequiredSubscriptionError(error) ||
                this.getStripeCardError(error) ||
                (this.TranslateSvc.has(error.toLowerCase()) && this.TranslateSvc.get(error.toLowerCase())) ||
                error);
        }
        else if (SubscriptionSvc.isStripeError(error)) {
            return error.message;
        }
        else {
            return error;
        }
    };
    SubscriptionSvc.prototype.findSubscriptionByName = function (displayName) {
        var _this = this;
        // search in upgrades
        var upgrade = this.getUpgradesByName(displayName);
        if (upgrade)
            return this.$q.resolve(upgrade);
        // search in current subscription
        return this.getDowngradesByName(null, displayName).then(function (downgrade) {
            if (downgrade)
                return downgrade;
            var currentSubscription = _this.getDetails();
            if (currentSubscription.displayName === displayName)
                return _this.$q.resolve(currentSubscription);
            return _this.$q.reject("Incorrect displayName = " + displayName);
        });
    };
    SubscriptionSvc.prototype.getPredictPrice = function (_a) {
        var displayName = _a.displayName, coupon = _a.coupon, params = tslib_1.__rest(_a, ["displayName", "coupon"]);
        var _this = this;
        return this.findSubscriptionByName(displayName)
            .then(function (_a) {
            var name = _a.name;
            return _this.HttpSvc('subscription/calculate').secureGet({
                params: tslib_1.__assign({}, params, { name: name, coupon: coupon || undefined })
            });
        })
            .then(function (r) { return r.data; });
    };
    SubscriptionSvc.prototype.isStripe = function () {
        return !this.isStripeError && options.user.isStripe();
    };
    SubscriptionSvc.prototype.getAnnualSave = function (upgrade) {
        if (upgrade === void 0) { upgrade = this.getDetails(); }
        return (upgrade.monthlyPrice * 12 - upgrade.annualPrice) / 100;
    };
    SubscriptionSvc.prototype.getAnnualPrice = function (details, discountPercentOff) {
        if (details === void 0) { details = this.getDetails(); }
        if (discountPercentOff === void 0) { discountPercentOff = details.discount && details.discount.percentOff; }
        return this.round((details.annualPrice * this.calcDiscount(discountPercentOff)) / 100 / 12);
    };
    SubscriptionSvc.prototype.getMonthlyPrice = function (details, discountPercentOff) {
        if (details === void 0) { details = this.getDetails(); }
        if (discountPercentOff === void 0) { discountPercentOff = details.discount && details.discount.percentOff; }
        return this.round((details.monthlyPrice * this.calcDiscount(discountPercentOff)) / 100);
    };
    SubscriptionSvc.prototype.isFree = function (currentSubscription) {
        if (currentSubscription === void 0) { currentSubscription = this.getDetails(); }
        var freeSubscriptions = ['WaveFree', 'Free'];
        return freeSubscriptions.includes(currentSubscription.name);
    };
    SubscriptionSvc.prototype.isHigh = function (currentSubscription) {
        if (currentSubscription === void 0) { currentSubscription = this.getDetails(); }
        var highSubscriptions = ['WaveBusiness', 'Business'];
        return highSubscriptions.includes(currentSubscription.name);
    };
    SubscriptionSvc.prototype.isSpecial = function (currentSubscription) {
        if (currentSubscription === void 0) { currentSubscription = this.getDetails(); }
        return this.specialSubscriptionNames.includes(currentSubscription.name);
    };
    SubscriptionSvc.prototype.isAppSumo = function (_a) {
        var _b = _a === void 0 ? this.getDetails() : _a, discount = _b.discount, name = _b.name;
        return (name.includes('AppSumo') ||
            (discount &&
                (discount.provider === 'AppSumo117' ||
                    (!true && discount.provider === 'MightyDeals417'))));
    };
    SubscriptionSvc.prototype.isCurrentOldPlan = function () {
        var oldPlans = ['WavePro', 'WaveAgency', 'WaveAgency2', 'WaveUltimate2'];
        var name = this.getDetails().name;
        return oldPlans.includes(name);
    };
    SubscriptionSvc.prototype.isSameOldPlan = function (period, planName) {
        var currentPlanName = this.getDetails().name;
        var monthlyPlanMap = {
            WavePro: 'Agency',
            WaveAgency2: 'Corporate'
        };
        var annualPlanMap = {
            WavePro: 'Pro',
            WaveAgency2: 'Agency',
            WaveUltimate2: 'Corporate'
        };
        var currentUserPlan = period === 'annual' ? annualPlanMap[currentPlanName] : monthlyPlanMap[currentPlanName];
        var isSamePlan = currentUserPlan === planName;
        return isSamePlan && this.isCurrentOldPlan();
    };
    SubscriptionSvc.prototype.getDetails = function () {
        var product = this.product.toLowerCase();
        var subscription = options.user.subscriptionDetails[product];
        return this.prepareSubscription(subscription);
    };
    SubscriptionSvc.prototype.setUpgradesDiscount = function () {
        var _this = this;
        this.affiliateSvc.getAffiliateUser().then(function (affiliateInfo) {
            _this.upgradesDiscount = affiliateInfo.discount;
        });
    };
    SubscriptionSvc.prototype.getSale = function (periodName) {
        var _this = this;
        if (underscore_extensions_1.Utils.isStudio())
            return this.$q.reject('no sale coupon for studio');
        var url = periodName === 'monthly' ? 'sale_monthly.json' : 'sale_annual.json';
        var path = "sale/" + underscore_extensions_1.Utils.getEnv();
        var params = tslib_1.__assign({}, this.productParams, { cache: this.getSaleCache });
        return this.HttpSvc(path, url)
            .setApiUrl('https://assets.animatron.com')
            .get(params)
            .then(this.handlerHttpResponse)
            .then(function (res) {
            _this.saleDiscount = res.discount * 100;
            return res;
        })
            .catch(function (errMsg) { return _this.$q.reject(errMsg); });
    };
    SubscriptionSvc.prototype.deleteCard = function () {
        var _this = this;
        return this.HttpSvc('subscription', 'card')
            .secureDelete(this.productParams)
            .then(this.handlerHttpResponse)
            .then(function (res) {
            _this.cardDetailsCashed = null;
            _this.cardDetailsErrorMessage = null;
            _this.isExpired = false;
            return res;
        });
    };
    SubscriptionSvc.prototype.getCardDetails = function () {
        var _this = this;
        return this.HttpSvc('subscription', 'history')
            .secureGet(this.productParams)
            .then(this.handlerHttpResponse)
            .then(function (res) {
            var hasCard = !!res.card;
            _this.isStripeError = hasCard && res.card.type === 'N/A';
            hasCard && _this.checkExpired(res.card.expires);
            _this.cardDetailsCashed = res;
            return res;
        })
            .catch(function (errMsg) {
            _this.isStripeError = true;
            _this.cardDetailsErrorMessage = errMsg;
            return _this.$q.reject(errMsg);
        });
    };
    SubscriptionSvc.prototype.getUpgradesByName = function (name) {
        var upgrade = this.getDetails().upgrades.filter(function (upgradeItem) { return upgradeItem && (upgradeItem.name === name || upgradeItem.displayName === name); })[0];
        return upgrade && this.prepareSubscription(upgrade);
    };
    SubscriptionSvc.prototype.getDowngradesByName = function (name, displayName) {
        var _this = this;
        return this.getDowngrades().then(function (downgrades) {
            var downgrade = downgrades.filter(function (downgradeItem) {
                return downgradeItem && (downgradeItem.name === name || downgradeItem.displayName === displayName);
            })[0];
            return downgrade && _this.prepareSubscription(downgrade);
        });
    };
    SubscriptionSvc.prototype.getUpgrades = function () {
        return this.getDetails().upgrades.filter(function (upgrade) { return !upgrade.excludeFromUI && !upgrade.hidden && upgrade.name !== 'WaveEnterprise'; });
    };
    SubscriptionSvc.prototype.getDowngrades = function () {
        return this.HttpSvc('subscription', 'downgrade')
            .secureGet(this.productParams)
            .then(this.handlerHttpResponse)
            .then(function (downgrades) {
            return downgrades.filter(function (downgrade) { return !downgrade.excludeFromUI && !downgrade.hidden; });
        });
    };
    SubscriptionSvc.prototype.cancelSubscription = function () {
        var _this = this;
        var _a = this.getDetails(), displayName = _a.displayName, billingPeriod = _a.billingPeriod;
        return this.HttpSvc('subscription', 'cancel')
            .secureDelete(this.productParams)
            .then(this.handlerHttpResponse)
            .then(function () {
            _this.cardDetailsCashed = null;
            _this.cardDetailsErrorMessage = null;
            _this.analyticSvc.changeSubscription('downgrade', displayName, billingPeriod);
            return _this.AuthenticationSvc.updateUser();
        });
    };
    SubscriptionSvc.prototype.checkExpired = function (expires) {
        var dateArr = expires.split('/');
        if (dateArr.length === 2) {
            var monthDays = underscore_extensions_1.Utils.getMonthDaysCount().toString();
            dateArr.splice(1, 0, monthDays);
        }
        var formattedDate = dateArr.join('/');
        var expiredDate = new Date(formattedDate).getTime();
        var currentDate = _.now();
        this.isExpired = currentDate >= expiredDate;
    };
    SubscriptionSvc.prototype.changeSubscription = function (params) {
        var _this = this;
        var request = function () {
            return _this.HttpSvc('subscription', 'change').securePut(params, {
                headers: _this.analyticSvc.getGaHeader()
            });
        };
        return this.changeSubscriptionErrorHandler(request);
    };
    SubscriptionSvc.prototype.changeSubscriptionErrorHandler = function (request) {
        var _this = this;
        var getErrorPromise = function () {
            var message = 'credit.card.processing.error.[expired_card]';
            var deferred = _this.$q.defer();
            deferred.resolve({ data: { code: 400, message: message } });
            return deferred.promise;
        };
        return this.isExpired ? getErrorPromise() : request();
    };
    SubscriptionSvc.prototype.updateCard = function (token) {
        var _this = this;
        var url = options.apiDomain + "/subscription/card/update";
        var headers = _.extend({
            'Content-Type': 'application/json'
        }, options.headers);
        return this.$http
            .post(url, { token: token }, { headers: headers })
            .then(function (r) {
            _this.$rootScope.$emit(exports.UPDATE_SUBSCRIPTION_CARD);
            return r;
        })
            .catch(function (err) {
            return err.status !== -1
                ? err
                : {
                    data: {
                        code: 400,
                        message: 'subscription.update-card.default-error'
                    }
                };
        });
    };
    SubscriptionSvc.prototype.round = function (num) {
        return Math.ceil(num);
    };
    SubscriptionSvc.prototype.calcDiscount = function (discount) {
        return discount ? 1 - discount / 100 : 1;
    };
    SubscriptionSvc.prototype.makeSpecialSubscription = function (subscription) {
        subscription.monthlyPrice = undefined;
        return subscription;
    };
    SubscriptionSvc.prototype.prepareSubscription = function (subscription) {
        return this.specialSubscriptionNames.includes(subscription.name)
            ? this.makeSpecialSubscription(subscription)
            : subscription;
    };
    SubscriptionSvc.prototype.showSubscriptionCanceledMessage = function () {
        var details = this.getDetails();
        var currentPlan = details.displayName;
        var expTime = details.expirationDate;
        var date = this.$filter('date')(expTime * 1000, 'short');
        var msg = expTime ? "Subscription will be canceled on " + date : 'Already canceled';
        _.notification.showSuccess(msg);
    };
    SubscriptionSvc.prototype.getStripeCardError = function (error) {
        var matched = error.match(/\[([A-Za-z_]+)\]/);
        var stripeKey = matched && matched[1];
        return stripeKey && this.TranslateSvc.has(stripeKey) ? this.TranslateSvc.get(stripeKey) : null;
    };
    SubscriptionSvc.prototype.getStripeCouponError = function (error) {
        var errorsCode = ['Coupon expired', 'No such coupon', 'Coupon is not valid', 'Coupon inapplicable'];
        var reg = new RegExp(errorsCode.join('|'));
        var isCouponError = _.isString(error) && reg.test(error);
        return isCouponError && this.TranslateSvc.get('coupon.error');
    };
    SubscriptionSvc.prototype.getRequiredSubscriptionError = function (error) {
        var isRequiredSubscriptionError = _.isString(error) && /required subscription:/.test(error);
        if (!isRequiredSubscriptionError)
            return false;
        var _a = error.match(/\(([0-9a-zA-Z]+)\|([0-9a-zA-Z]+)\)/), plan = _a[1], period = _a[2];
        var subscriptionName = plan + " " + period;
        var productName = underscore_extensions_1.Utils.getProduct().toLowerCase();
        var coupon = this.$state.params.coupon;
        var upgradeParams = underscore_extensions_1.Utils.toParams({
            plan: plan,
            coupon: coupon,
            period: period.toLowerCase()
        });
        var productUrl = underscore_extensions_1.Utils.getProduct() === 'WAVE' ? '' : "/" + productName;
        var url = productUrl + "/pricing/upgrade?" + upgradeParams;
        return this.TranslateSvc.get('required.subscription.error', url, subscriptionName);
    };
    return SubscriptionSvc;
}());
exports.SubscriptionSvc = SubscriptionSvc;
angular.module('animatronApp.SubscriptionSvc', []).service('subscriptionSvc', SubscriptionSvc);


/***/ }),

/***/ "WF19":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var PlanAnimation = (function () {
    PlanAnimation.$inject = ["$rootScope", "$element"];
    function PlanAnimation($rootScope, $element) {
        this.$rootScope = $rootScope;
        this.$element = $element;
    }
    PlanAnimation.prototype.$onInit = function () {
        var _this = this;
        if (options.handHeld)
            return;
        underscore_extensions_1.Utils.rAF(function () {
            var _a = _this.$element[0].parentElement.getBoundingClientRect(), width = _a.width, height = _a.height;
            _this.url = PlanAnimation.Animations[_this.plan.toLowerCase()];
            _this.width = width;
            _this.height = height;
            var video = _this.$element[0].querySelector('video');
            var safe = function (f) { return video && _.isFunction(video[f]) && video[f](); };
            _this.$rootScope.$on("onScreen:" + _this.url, function () { return safe('play'); });
            _this.$rootScope.$on("notOnScreen:" + _this.url, function () { return safe('pause'); });
            _this.inited = true;
        });
    };
    PlanAnimation.prototype.$onDestroy = function () {
        _.isFunction(window.stop) && window.stop();
    };
    return PlanAnimation;
}());
PlanAnimation.Animations = _.object(['free', 'pro', 'business'].map(function (plan) {
    return [plan, "https://videos.animatron.com/pricing/" + plan + (options.retina ? '_2x' : '') + ".mp4"];
}));
angular.module('animatronApp.planAnimation', []).component('planAnimation', {
    bindings: {
        plan: '@'
    },
    controller: PlanAnimation,
    template: "<div ng-if=\"::$ctrl.inited\" id=\"player-{{::$ctrl.plan.toLowerCase()}}\" class=\"animation\">\n                    <video width=\"{{::$ctrl.width}}\" height=\"{{::$ctrl.height}}\" \n                           ng-if=\"::!$root.options.handHeld\"\n                           preload autoplay muted loop playsinline webkit-playsinline>\n                        <source ng-src=\"{{::$ctrl.url}}\" type=\"video/mp4\">\n                        <source ng-src=\"{{::$ctrl.url.replace('mp4', 'webm')}}\" type=\"video/webm\">\n                    </video>\n                    <div id=\"{{::$ctrl.url}}\" class=\"middle\" is-on-screen></div>\n               </div>"
});


/***/ }),

/***/ "YMs+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var TypeformSvc = (function () {
    TypeformSvc.$inject = ["$state", "$stateParams", "$q", "TranslateSvc", "subscriptionSvc", "AuthenticationSvc", "HttpSvc"];
    function TypeformSvc($state, $stateParams, $q, TranslateSvc, subscriptionSvc, AuthenticationSvc, HttpSvc) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.TranslateSvc = TranslateSvc;
        this.subscriptionSvc = subscriptionSvc;
        this.AuthenticationSvc = AuthenticationSvc;
        this.HttpSvc = HttpSvc;
        this.showDeletedModal = false;
        this.userId = this.$stateParams.userid;
    }
    TypeformSvc.prototype.openTypeFormCancel = function () {
        var formId = this.getProduct() === 'wave' ? 'K6si1N' : 'oOu1yB';
        var typeformUrl = this.getUrl('downgrade', formId);
        window.open(typeformUrl, '_self');
    };
    TypeformSvc.prototype.openTypeFormDelete = function () {
        var formId = this.getProduct() === 'wave' ? 'W3TtpN' : 'OcPZVX';
        var typeformUrl = this.getUrl('delete', formId);
        this.deleteAccountRequest().then(function () { return window.open(typeformUrl, '_self'); });
    };
    TypeformSvc.prototype.deleteAccountRequest = function () {
        var _this = this;
        return this.HttpSvc('profile')
            .secureDelete()
            .then(function (data) {
            return underscore_extensions_1.Utils.isApiError(data)
                ? _this.$q.reject(data.message)
                : data;
        })
            .then(function () { return _this.AuthenticationSvc.logout(); })
            .catch(function (err) { return _.notification.showError(err); });
    };
    TypeformSvc.prototype.getProduct = function () {
        return underscore_extensions_1.Utils.getProduct().toLowerCase();
    };
    TypeformSvc.prototype.getUrl = function (action, typeformId) {
        var url = location.host + "/" + this.getProduct();
        if (action === 'downgrade') {
            url = url + "/settings/subscription";
        }
        return "https://animatron.typeform.com/to/" + typeformId + "?email=" + options.user.email;
    };
    TypeformSvc.prototype.isLogged = function () {
        if (!this.AuthenticationSvc.loggedIn) {
            this.openModalLogin();
            return false;
        }
        if (this.userId !== options.user.userId) {
            this.AuthenticationSvc.logout();
            this.openModalLogin();
            return false;
        }
        return true;
    };
    TypeformSvc.prototype.openModalLogin = function () {
        var _this = this;
        var currentUrl = this.$state.current.url + "=" + this.$stateParams.userid;
        var message = this.TranslateSvc.get('login.redirect-email');
        this.$state
            .go(this.getProduct() + "-landing")
            .then(function () { return setTimeout(function () { return _this.AuthenticationSvc.toggleLoginModal(currentUrl, message); }, 0); });
    };
    return TypeformSvc;
}());
exports.TypeformSvc = TypeformSvc;
angular.module('animatronApp.settings').service('typeformSvc', TypeformSvc);


/***/ }),

/***/ "edCO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var SubscriptionSvc_1 = __webpack_require__("VXOl");
var underscore_extensions_1 = __webpack_require__("R0iF");
exports.PREDICT_PRICE_ERROR = 'website/subscription/predictPriceError';
var SubscriptionPredictPriceContainer = (function () {
    SubscriptionPredictPriceContainer.$inject = ["$q", "$scope", "$state", "subscriptionMessageSvc", "subscriptionCouponMessageSvc", "$stateParams", "$rootScope", "subscriptionSvc"];
    function SubscriptionPredictPriceContainer($q, $scope, $state, subscriptionMessageSvc, subscriptionCouponMessageSvc, $stateParams, $rootScope, subscriptionSvc) {
        var _this = this;
        this.$q = $q;
        this.$scope = $scope;
        this.$state = $state;
        this.subscriptionMessageSvc = subscriptionMessageSvc;
        this.subscriptionCouponMessageSvc = subscriptionCouponMessageSvc;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.subscriptionSvc = subscriptionSvc;
        this.applyCouponListener = _.noop;
        this.handlerHttpResponse = function (responses) {
            var deferred = _this.$q.defer();
            var errors = [];
            responses.forEach(function (res) {
                if (underscore_extensions_1.Utils.isApiError(res)) {
                    errors.push(_this.subscriptionSvc.getError(res.message));
                }
            });
            if (errors.length > 0) {
                deferred.reject(errors);
            }
            else {
                deferred.resolve(responses);
            }
            return deferred.promise;
        };
        this.setCoupon();
        this.applyCouponListener = this.$rootScope.$on(SubscriptionSvc_1.APPLY_COUPON, function (e, coupon) { return _this.init(coupon); });
    }
    SubscriptionPredictPriceContainer.prototype.$onDestroy = function () {
        this.applyCouponListener();
    };
    SubscriptionPredictPriceContainer.prototype.$onChanges = function (onChangesObj) {
        if (!onChangesObj.period || onChangesObj.period.isFirstChange())
            return;
        this.$rootScope.$emit(exports.PREDICT_PRICE_ERROR, ''); // clear previous error message
        this.currentPeriod = onChangesObj.period.currentValue.toLowerCase();
        this.subscriptionSvc.isFree()
            ? this.updatePriceWithSale()
            : this.updateRouterParams();
    };
    SubscriptionPredictPriceContainer.prototype.updatePriceWithSale = function () {
        var _this = this;
        this.subscriptionSvc
            .getSale(this.currentPeriod)
            .then(function (_a) {
            var coupon = _a.coupon;
            _this.updateRouterParams(coupon);
        })
            .catch(function () {
            _this.updateRouterParams();
        });
    };
    SubscriptionPredictPriceContainer.prototype.updateRouterParams = function (coupon) {
        var _this = this;
        this.$state
            .go(this.$state.current, tslib_1.__assign({}, this.$stateParams, { coupon: coupon || this.$stateParams.coupon, period: this.currentPeriod }), { notify: false })
            .finally(function () {
            !_this.loading && _this.setCoupon();
        });
    };
    SubscriptionPredictPriceContainer.prototype.init = function (coupon) {
        var _this = this;
        this.setCurrentSubscription(coupon).then(function () { return _this.setPrice(); });
    };
    SubscriptionPredictPriceContainer.prototype.setCoupon = function () {
        if (this.hide)
            return;
        this.init(this.$stateParams.coupon);
    };
    SubscriptionPredictPriceContainer.prototype.setCurrentSubscription = function (coupon) {
        var _this = this;
        this.loading = true;
        return this.$q
            .all([this.getPredictPrice(coupon), this.getStaticSubscription()])
            .then(this.handlerHttpResponse)
            .then(function (subscriptions) {
            var predictSubscription = subscriptions[0], staticSubscription = subscriptions[1];
            _this.predictSubscription = predictSubscription;
            _this.staticSubscription = staticSubscription;
        })
            .catch(function (errors) {
            _this.subscriptionMessageSvc.hideMassage();
            _this.$rootScope.$emit(exports.PREDICT_PRICE_ERROR, errors[0]);
            return _this.$q.reject(errors);
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    SubscriptionPredictPriceContainer.prototype.setPrice = function () {
        var _a = this.$stateParams, period = _a.period, plan = _a.plan;
        if (!plan)
            return;
        this.currentPeriod = this.currentPeriod || period;
        var _b = this.staticSubscription, annualPrice = _b.annualPrice, monthlyPrice = _b.monthlyPrice, displayName = _b.displayName;
        this.planName = displayName;
        // transform prices from array to object
        var pricesObj = this.predictSubscription.prices.reduce(function (prices, price) {
            if (price.period === 'ANNUAL') {
                prices.annual = price;
            }
            else if (price.period === 'MONTHLY') {
                prices.monthly = price;
            }
            return prices;
        }, {});
        var currentPredictPriceData;
        if (this.currentPeriod === 'annual') {
            currentPredictPriceData = pricesObj.annual;
            this.currentPrice = (monthlyPrice * 12) / 100 || annualPrice / 100;
            this.annualDiscount = this.currentPrice - annualPrice / 100;
        }
        else if (this.currentPeriod === 'monthly') {
            currentPredictPriceData = pricesObj.monthly;
            this.currentPrice = monthlyPrice / 100;
            this.annualDiscount = null;
        }
        else {
            throw new Error('incorrect period name');
        }
        this.setupDiscount(currentPredictPriceData);
        var currentPredictPrice = currentPredictPriceData.price / 100;
        var currentPredictPriceRounded = this.subscriptionSvc.round(currentPredictPrice);
        var startingBalance = this.subscriptionSvc.round(this.predictSubscription.startingBalance / 100);
        this.credit = startingBalance < 0 ? -startingBalance : 0;
        this.totalPrice =
            currentPredictPriceRounded >= 0 ? currentPredictPriceRounded : 0;
        this.subscriptionSvc.totalPriceLastValue = this.totalPrice;
    };
    SubscriptionPredictPriceContainer.prototype.setupDiscount = function (_a) {
        var discount = _a.discount;
        this.subscriptionMessageSvc.hideMassage();
        if (!discount)
            return;
        var error = discount.error, amount = discount.amount, percents = discount.percents;
        if (error) {
            this.$rootScope.$emit(exports.PREDICT_PRICE_ERROR, this.subscriptionSvc.getError(error));
        }
        else {
            this.amountDiscount = amount / 100;
            this.percentsDiscount = percents;
            var message = this.subscriptionCouponMessageSvc.get(discount);
            this.subscriptionMessageSvc.showSuccess(message);
        }
    };
    SubscriptionPredictPriceContainer.prototype.getStaticSubscription = function () {
        return this.subscriptionSvc.findSubscriptionByName(this.$stateParams.plan);
    };
    SubscriptionPredictPriceContainer.prototype.getPredictPrice = function (coupon) {
        var _a = this.$stateParams, plan = _a.plan, period = _a.period;
        return this.subscriptionSvc.getPredictPrice({
            period: period,
            coupon: coupon,
            displayName: plan
        });
    };
    return SubscriptionPredictPriceContainer;
}());
angular
    .module('animatronApp.SubscriptionPredictPriceContainer', [])
    .component('subscriptionPredictPriceContainer', {
    bindings: {
        period: '<',
        hide: '<'
    },
    controller: SubscriptionPredictPriceContainer,
    templateUrl: __webpack_require__("gGiH")
});


/***/ }),

/***/ "gGiH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-predict-price-container_cac2967847b1834ec43c5533b61a6bf7.html";

/***/ }),

/***/ "gojZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CouponDirective = (function () {
    CouponDirective.$inject = ["$state", "HttpSvc", "AuthenticationSvc"];
    function CouponDirective($state, HttpSvc, AuthenticationSvc) {
        this.$state = $state;
        this.HttpSvc = HttpSvc;
        this.AuthenticationSvc = AuthenticationSvc;
        this.coupon = this.$state.params.coupon;
        this.placeholder = 'Enter your coupon code here';
    }
    CouponDirective.prototype.applyCoupon = function (coupon) {
        var _this = this;
        this.couponError = undefined;
        this.applyingCoupon = true;
        this.HttpSvc('coupon', coupon)
            .securePost()
            .then(function (r) { return r.data; })
            .then(function (response) {
            if (_.isObject(response) && response.code !== 200) {
                _this.couponError = response.message;
            }
            else {
                _this.coupon = '';
                _this.AuthenticationSvc.notifyUserChange();
                _this.AuthenticationSvc.updateUser().then(function () {
                    _this.SubscriptionCtrl.updateSubscriptionDetails();
                    _this.SubscriptionCtrl.upgradedTo = response.message;
                    _this.SubscriptionCtrl.toggleAppSumoUpgradeResultModal();
                });
            }
        })
            .finally(function () { return (_this.applyingCoupon = false); });
    };
    return CouponDirective;
}());
angular.module('animatronApp.settings').component('coupon', {
    bindings: { placeholder: '@' },
    require: { SubscriptionCtrl: '^subscription' },
    controller: CouponDirective,
    templateUrl: __webpack_require__("52SV")
});


/***/ }),

/***/ "ipbz":
/***/ (function(module, exports, __webpack_require__) {

/*
Certificate code:
Old: mhttp://youtrack.animatron.com/youtrack/issue/WEB-683
New: https://youtrack.animatron.com/youtrack/issue/WEB-2649
 */
var SecurePayment = (function () {
    function SecurePayment() {
        this.imageSrc = 'https://wwwsslcom.a.cdnify.io/assets/ssl_seal_1-3dfcdf69a9e544495dbcf366a74ee5c4baca7e4f8018f7ddfa22f2de9bcf464d.png';
    }
    SecurePayment.prototype.getHref = function () {
        return "https://www.ssl.com/team/a3d-1b33o49/site_seals/" + this.getId() + "/site_report";
    };
    SecurePayment.prototype.openWindow = function (e) {
        e.preventDefault();
        window.open("https://www.ssl.com/team/a3d-1b33o49/site_seals/" + this.getId() + "/site_report", 'site_report', 'height=500, width=400, top=100, left=100');
    };
    SecurePayment.prototype.getId = function () {
        var user = options.user, isProduction = true;
        return user.zoneCode === 'kr'
            ? '4c157bc0-57032320' : isProduction
            ? '4f7e3f09-59fb2fa3'
            : '48ed36cd-59a99ce5';
    };
    return SecurePayment;
}());
angular.module('animatronApp.settings').component('securePayment', {
    controller: SecurePayment,
    template: "<div class=\"subscription-secure-payment\">\n                    <a \n                        ng-click=\"$ctrl.openWindow($event)\"\n                        href=\"{{ $ctrl.getHref() }}\">\n                         <img \n                              ng-src=\"{{ $ctrl.imageSrc }}\"\n                              alt=\"Ssl seal 1\"/>\n                    </a>\n                    <span>Secure credit card payment</span>\n              </div>"
});


/***/ }),

/***/ "izVX":
/***/ (function(module, exports, __webpack_require__) {

var subscriptionTypesData = {
    free: [
        'subscription.public-projects',
        'subscription.watermark',
        'subscription.limited-export-formats'
    ],
    starter: [
        'subscription.unlimited-public-projects',
        'subscription.unlisted-projects',
        'subscription.import-stuff',
        'subscription.limited-export-formats',
        'subscription.no-end-screen',
        'subscription.basic-permissions'
    ],
    pro3: [
        'subscription.unlimited-projects',
        'subscription.no-watermark',
        'subscription.collaborative-video'
    ],
    business: [
        'subscription.unlimited-projects',
        'subscription.available-features',
        'subscription.premium-storage',
        'subscription.priority-rendering',
        'subscription.premium-support'
    ],
    wavefree: [
        'wv.subscription.5-videos',
        'wv.subscription.limited-clips',
        'wv.subscription.watermark'
    ],
    wavepro: [
        'wv.subscription.small-businesses',
        'wv.subscription.1-brand',
        'wv.subscription.3m-royalty-free',
        'wv.subscription.no-watermark',
        'wv.subscription.unlimited-videos-per-month'
    ],
    wavebusiness: [
        'wv.subscription.corporate-marketers',
        'wv.subscription.600-royalty-free',
        'wv.subscription.premium-clips',
        'wv.subscription.no-watermark',
        'wv.subscription.unlimited-videos',
        'wv.subscription.customer-support'
    ],
    waveagency: [
        'wv.subscription.corporate-marketers',
        'wv.subscription.20brands',
        'wv.subscription.white-label-preview',
        'wv.subscription.no-watermark',
        'wv.subscription.3m-stock',
        'wv.subscription.unlimited-videos',
        'wv.subscription.customer-support'
    ],
    wavebigagency: [
        'wv.subscription.Ideal-for-agencies',
        'wv.subscription.2.5-million-video',
        'wv.subscription.3rd-party-sell-them',
        'wv.subscription.videos-for-many-brands',
        'wv.subscription.Import-100Gb-media'
    ],
    waveultimate: [
        'wv.subscription.ideal-for-create-videos',
        'wv.subscription.50brands',
        'wv.subscription.3m-stock',
        'wv.subscription.white-label-preview',
        'wv.subscription.no-watermark',
        'wv.subscription.unlimited-videos',
        'wv.subscription.customer-support'
    ],
    wavesmallagency: [
        'wv.subscription.best-for-small-agencies',
        'wv.subscription.2.5-million-video',
        'wv.subscription.3rd-party-someone-else',
        'wv.subscription.videos-for-many-brands'
    ]
};
var SubscriptionTypes = (function () {
    function SubscriptionTypes() {
    }
    SubscriptionTypes.prototype.$onChanges = function () {
        this.types = subscriptionTypesData[this.subscriptionName.toLowerCase()];
    };
    return SubscriptionTypes;
}());
angular.module('animatronApp.settings').component('subscriptionTypes', {
    bindings: {
        subscriptionName: '<'
    },
    controller: SubscriptionTypes,
    templateUrl: __webpack_require__("F5f2")
});


/***/ }),

/***/ "o701":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-price-block_d930eeb8cc868aec2efbcce26babaecd.html";

/***/ }),

/***/ "py5d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription_f8e45eaaaa4dc29e14b93d8ec50d2004.html";

/***/ }),

/***/ "rCIs":
/***/ (function(module, exports) {

angular.module('animatronApp.settings').directive('upgradePlan', function () {
    return function (_, $rootScope) {
        $rootScope.coupon = {};
    };
});


/***/ }),

/***/ "x7sC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CouponDirective = (function () {
    CouponDirective.$inject = ["$state", "HttpSvc", "AuthenticationSvc"];
    function CouponDirective($state, HttpSvc, AuthenticationSvc) {
        this.$state = $state;
        this.HttpSvc = HttpSvc;
        this.AuthenticationSvc = AuthenticationSvc;
        this.coupon = this.$state.params.coupon;
    }
    CouponDirective.prototype.applyCoupon = function (coupon) {
        var _this = this;
        this.couponError = undefined;
        this.applyingCoupon = true;
        this.HttpSvc('coupon', coupon)
            .securePost()
            .then(function (r) { return r.data; })
            .then(function (response) {
            if (_.isObject(response) && response.code !== 200) {
                _this.couponError = response.message;
            }
            else {
                _this.coupon = '';
                _this.AuthenticationSvc.notifyUserChange();
                _this.AuthenticationSvc.updateUser().then(function () {
                    _this.SubscriptionCtrl.updateSubscriptionDetails();
                    _this.SubscriptionCtrl.upgradedTo = response.message;
                    _this.SubscriptionCtrl.toggleUpgradeResultModal(function () {
                        return _this.$state.go('studio-settings.subscription');
                    });
                });
            }
        })
            .finally(function () { return (_this.applyingCoupon = false); });
    };
    return CouponDirective;
}());
angular.module('animatronApp.settings').component('redeemCoupon', {
    require: { SubscriptionCtrl: '^subscription' },
    controller: CouponDirective,
    templateUrl: __webpack_require__("6B7s")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/3-40ecf89b893baa28ab63.min.js